module.exports = __webpack_public_path__ + "static/media/emprunteur_plus.ba34f877.png";